import { EntityModel } from '@/interfaces'
import {
  ALL_BUTTON_BLOCKS_QUERY,
  CREATE_BUTTON_BLOCK_MUTATION,
  DELETE_BUTTON_BLOCK_MUTATION,
  FORCE_DELETE_BUTTON_BLOCK_MUTATION,
  SINGLE_BUTTON_BLOCK_QUERY,
  UPDATE_BUTTON_BLOCK_MUTATION,
} from './graphql'
import linkEntity from '@/entities/link/entity'

const cmsButtonBlockModel: EntityModel = {
  name: 'buttonBlock',
  namePlural: 'buttonBlocks',
  uniqueName: 'cmsButtonBlock',
  uniqueNamePlural: 'cmsButtonBlocks',
  path: 'cms/blocks/button_block',
  baseUrl: '/cms/blocks/button_blocks',
  translationPrefix: 'entities:cmsButtonBlock.',
  getDisplayName: (values: any) => {
    return 'Button block'
  },
  gql: {
    getAll: ALL_BUTTON_BLOCKS_QUERY,
    getSingle: SINGLE_BUTTON_BLOCK_QUERY,
    create: CREATE_BUTTON_BLOCK_MUTATION,
    update: UPDATE_BUTTON_BLOCK_MUTATION,
    delete: DELETE_BUTTON_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_BUTTON_BLOCK_MUTATION,
  },
  attributes: {
    variant: {
      name: 'variant',
      label: 'entities:cmsButtonBlock.attributes.variant.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'primary',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsButtonBlock.attributes.variant.selectOptions.primary.label',
          value: 'primary',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.variant.selectOptions.secondary.label',
          value: 'secondary',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.variant.selectOptions.tertiary.label',
          value: 'tertiary',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.variant.selectOptions.quaternary.label',
          value: 'quaternary',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.variant.selectOptions.signal.label',
          value: 'signal',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    size: {
      name: 'size',
      label: 'entities:cmsButtonBlock.attributes.size.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'medium',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsButtonBlock.attributes.size.selectOptions.small.label',
          value: 'small',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.size.selectOptions.medium.label',
          value: 'medium',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.size.selectOptions.large.label',
          value: 'large',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    position: {
      name: 'position',
      label: 'entities:cmsButtonBlock.attributes.position.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'center',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsButtonBlock.attributes.position.selectOptions.left.label',
          value: 'left',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.position.selectOptions.center.label',
          value: 'center',
        },
        {
          label: 'entities:cmsButtonBlock.attributes.position.selectOptions.right.label',
          value: 'right',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    link: {
      name: 'link',
      label: 'entities:cmsButtonBlock.attributes.link.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return linkEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsButtonBlockModel
